import { submitSubscriptionPlansFormNewRoutine } from './subscription_plans_routines'
import {call, delay} from 'redux-saga/effects'
// import { newItem } from '../item/item_new_saga.js'
import genericFormSubmissionSaga from '../item/genericFormSubmissionSaga'
import {
  getPortalCurrentOrganisationAndCatalogIds, getPortalCurrentOrganisationId,
  getPortalOrganisationSparkyManagerEndpoint, stateIsPortalDebug
} from "../portal/portal_selectors";
import {stateFindResourceByIds} from "../resource/resource_selectors";
import {put, select} from "@redux-saga/core/effects";
import {
  buildExternalResourceInfos,
  buildExternalResourceUri,
  external_resource_schemes
} from "../../utils/urls/external";
import {postUrlJson} from "../../utils/fetch";
import HttpStatusError from "../../utils/error/HttpStatusError";
import {getFirstDef} from "../../utils/objtools";
import {modalAdd} from "../modals/modals_actions";
import i18n from "../../utils/lang/i18n";

function* saga(action) {
  const {values, modalInfos} = action.payload

  // prepare some ids
  var ids = yield select(getPortalCurrentOrganisationAndCatalogIds)
  ids.consorg_id = values.selected_consorg_id

  ids.application_id = values.application.value


  // Get the consorg to have its ids propagate in reloaded lists and for later go to the app URL
  var consorg = yield select(stateFindResourceByIds, 'consorg', ids)
  if (!consorg) {
    throw new Error('Consumer Organization not found.')
  }

  ids = {
    ...consorg.ids,
    ...ids
  }

  var body = {
    claims: {}
  }

  body.claims[values.productId] = [values.name]

  var saga_error = null
  var url = null
  var status = null
  var data = null

  var new_scheme_key = "subscription_plan_new"



  try {
    const sparky_manager_api_endpoint = yield select(getPortalOrganisationSparkyManagerEndpoint)
    if (!sparky_manager_api_endpoint)
      throw new Error("Could not get manager's api endpoint.")
    const organization_id = yield select(getPortalCurrentOrganisationId)
    if (!organization_id)
      throw new Error("Could not get organization_id.")

    var uri = yield buildExternalResourceUri(new_scheme_key, ids)
    if (!uri)
      throw new Error("Could not build the creation uri.")

    url = sparky_manager_api_endpoint + uri

    const {fetch_response, fetch_error} = yield call(postUrlJson, url, body, organization_id)
    if (fetch_error)
      throw fetch_error
    if (!fetch_response)
      throw new Error ('Could not get response')
    status = fetch_response.status
    if (fetch_response.status !== 200 && fetch_response.status !== 201)  {

      var error_response = yield fetch_response.json()

      modalInfos.closeModal()
      yield delay(200)

      yield put(modalAdd(
        'error',
        {
          title: fetch_response.status,
          message: getFirstDef(error_response.errors[0], 'defaultMessage', ''),
          error_code: error_response.errors[0].errorCode,
          subject: error_response.errors[0].subject,
          request_id: error_response.requestId,
          timestamp: error_response.timestamp,
        }
      ))

      throw new HttpStatusError(fetch_response.status)
    }
    data = yield fetch_response.json()

    if (!data[0].name)
      throw new Error("No name found in the created item.")

    // Store refresh when requested by new scheme
    const new_scheme = external_resource_schemes[new_scheme_key]
    for (var refresh_force_resource_scheme_key of getFirstDef(new_scheme, 'refresh_force_resources', [])) {
      var external_resource_infos_to_refresh = buildExternalResourceInfos(refresh_force_resource_scheme_key, ids)
      yield put({type: 'RESOURCE_LOAD_REQUEST', external_resource_infos: external_resource_infos_to_refresh, force:true})
    }

    if (data){
      for (let claim of data){
        if(!claim.name){
          throw new Error('A plan name is missing in the subscription response')
        }
        if(!claim.state){
          throw new Error('A plan is missing in the subscription response')
        }
      }
    }

    modalInfos.closeModal()

    // Subscription recap
    yield put(modalAdd(
      'summary',
      {
        title: i18n.t('subscriptionplans:subscription_summary_modal_title'),
        message: i18n.t('subscriptionplans:subscription_summary_modal_message'),
        summary_list: data,
        // warning: i18n.t('subscriptionplans:subscription_summary_modal_warning'),
      }
    ))

    // Extend IDs and specify tab_code
    ids = {
      ...ids,
      tab_code: 'subscriptions'
    }

    yield put({type: 'HISTORY_PUSH_BY_RESOURCE', scheme_key:'application', scheme_key_resource:'application', ids})

  }

  catch (catched_error) {
    saga_error = catched_error
  }

  if (yield select(stateIsPortalDebug)) {
    yield put({type: 'LOG_EXTERNAL_QUERY', scheme_key: new_scheme_key, url, status, has_error: saga_error?true:false, has_data: data?true:false})
  }

  if (saga_error) {
    yield put({type: 'ITEM_QUERY_ERROR', query_scheme_key: new_scheme_key, error: saga_error})
    return {error: saga_error}
  }

}

export function* submitNewSubscriptionPlansForm(action) {
  yield call(genericFormSubmissionSaga, {
    saga,
    action,
    routine: submitSubscriptionPlansFormNewRoutine,
    successfull_title: 'subscriptionplans:successfull_create_title',
    successfull_body: 'subscriptionplans:successfull_create_body',
    unsuccessfull_title: 'subscriptionplans:unsuccessfull_create_title',
    unsuccessfull_body: 'subscriptionplans:unsuccessfull_create_body'
  })
}
